export default __webpack_public_path__ + "850a7de4a8597919fb036462b5cb1a9e.png";